module.exports = __webpack_public_path__ + "static/img/Bachelor_010275.1a87397.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010275.jpg
// module id = 135
// module chunks = 0